import { render, staticRenderFns } from "./auditCompanyInvoiceBox.vue?vue&type=template&id=0b457720"
import script from "./auditCompanyInvoiceBox.vue?vue&type=script&lang=js"
export * from "./auditCompanyInvoiceBox.vue?vue&type=script&lang=js"
import style0 from "./auditCompanyInvoiceBox.vue?vue&type=style&index=0&id=0b457720&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports